/**
 * Heavily modified from @react/react-spectrum/utils/configureTypekit.js to add control flow possibilities
 * The unused class-based reporting of font-loading is replaced by a promise.
 *
 * Font loading is done for a particular language, with most languages mapped to a default Typekit and a few
 * east-asian languages mapped to specific kits.
 *
 * Please note that a single Typekit font can be successfully loaded. The assumption is that the non-default kits
 * will display default languages correctly.
 */

import DomUtil from '../dom-util';

/*eslint-disable camelcase*/
const LANGUAGE_KIT_MAPPING = {
	DEFAULT: 'vod7kbb',
	'str-ja': 'buh4foi',
	'str-ko': 'dmd3ucv',
	'str-zh-cn': 'kod2twa',
	'str-zh-tw': 'vtp8bzy'
};
/*eslint-enable camelcase*/

//Timeouts that ensure the promises resolve or reject eventually even if Typekit fails to respond. The values are Typekit defaults.
const SCRIPT_LOAD_TIMEOUT = 3000;
const FONT_LOAD_TIMEOUT = 3000;

const loadTypekitScript = (kitId) => {
	return new Promise((resolve, reject) => {
		// Do not load two kits
		if (window.Typekit) {
			resolve();
			return;
		}

		let scriptTimeout;

		const onFailure = () => {
			clearTimeout(scriptTimeout);
			reject();
		};

		const onSuccess = () => {
			clearTimeout(scriptTimeout);
			resolve();
		};

		scriptTimeout = setTimeout(onFailure, SCRIPT_LOAD_TIMEOUT);
		DomUtil.asyncScriptLoad('https://use.typekit.net/' + kitId + '.js', onSuccess, onFailure);
	});
};

const loadTypekitFont = () => {
	return new Promise((resolve, reject) => {
		let timeout;

		const onSuccess = () => {
			clearTimeout(timeout);
			resolve();
		};

		const onFailure = () => {
			clearTimeout(timeout);
			reject();
		};

		timeout = setTimeout(onFailure, FONT_LOAD_TIMEOUT);
		try {
			window.Typekit.load({
				active: onSuccess,
				inactive: onFailure
			});
		} catch (error) {
			onFailure();
		}
	});
};

export default function loadFont(language) {
	const typekitId = LANGUAGE_KIT_MAPPING[language] || LANGUAGE_KIT_MAPPING.DEFAULT;
	return loadTypekitScript(typekitId).then(loadTypekitFont);
}